import ProductDetails from "./product-details";

export default ProductDetails;
